import { useQuery } from "@tanstack/react-query";
import axios from "../../axiosConfig";
import { GET_CHANGE_ORDER_DETAILS } from "../queries/GetOrderDetails";

//Get actual hours on a order
const fetchChangeOrderDetails = async ({ queryKey }) => {
    const [, { token, item}] = queryKey;

    if (!token) throw new Error('Token not available');

    let valuesList = [];

    let mappedValues = {
      ESOI: item.esoi,
      SO: item.so,
      LongChanges: 0,
    };

    valuesList = [mappedValues];

    try {
        const response = await axios.post(
            `/getChangeOrderDetails/`,
              valuesList, 
            {
              headers: {
                Authorization: token,
              },
            }
          );
        return response.data;

    } catch (error) {
        throw new Error(error.response?.data || "Error fetching data");
    }
};

export const useGetChangeOrderDetails = (params) => {
    return useQuery({
        queryKey: [GET_CHANGE_ORDER_DETAILS, params],
        queryFn: fetchChangeOrderDetails,
        enabled: !!params.token,
        retry: false,
    });
};